import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet, isActive, setActive, selectedItems, setSelectedItems }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    // useEffect(() => {
    //     if (selectedFiltersCount > 0) {
    //         setActive(true)
    //     }

    // }, [selectedFiltersCount])

    function updateOrderedArray(array, order) {
        return array.sort((a, b) => order.indexOf(a.value.toUpperCase()) - order.indexOf(b.value.toUpperCase()))
    }

    const isSize = facet.name.toLowerCase() === "size"

    if (isSize) {
        let sortIt = ["XXS", "XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL", "XXXL", "OS"];
        updateOrderedArray(facet.data, sortIt);
    }

    // console.log(facet);

    return (
        <li class={`ns-sidebar-dropdown ${isActive ? "ns-active" : ""}`}>
            <a
                class="ns-d-flex ns-align-items-center ns-relative ns-border-box ns-text-undecorated ns-p-4"
                href="javascript:void(0)"
                data-nosto-element="facet"
                // onClick={toggleActive}
                onClick={() => {
                    setActive(!isActive)
                }}
            >
                <span class="ns-color-black nosto-facet-title">{facet.name}</span>
                {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )}
                <Icon name="arrow" className="ns-ml-2" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                {facet.name != "Color" ? (<ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map(value => (
                        <li
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span>
                        </li>
                    ))}
                </ul>) : (
                    <ul class="facets__list list-unstyled facets__list--color" role="list">
                        {facet.data?.map((value, index) => {
                            const isBlackOrWhite = value.value === "Black" || value.value === "White";
                            const sanitizedValue = value.value.toLowerCase().replaceAll(" ", "-");
                            const hexColor = value.value === "Black" ? "#000000" : "#FFFFFF";
                            
                            const labelStyle = isBlackOrWhite
                                ? `background-color: ${hexColor};`
                                : `background-size: cover; background-image: url(https://cdn.shopify.com/s/files/1/0158/2548/files/${sanitizedValue}.jpg)`;

                            return (
                                <li class="list-menu__item facets__item" data-value={sanitizedValue}>
                                    <input
                                        type="checkbox"
                                        name="filter.v.option.color"
                                        value={value.value}
                                        data-value={sanitizedValue}
                                        id={`Filter-Color-${index}`}
                                        checked={value.selected}
                                    />
                                    <label
                                        onClick={(e) => {
                                            e.preventDefault();
                                            //e.currentTarget.classList.toggle("is-selected");
                                            toggleProductFilter(facet.field, value.value, !value.selected);
                                        }}
                                        data-tooltip={value.value}
                                        htmlFor={`Filter-Color-${index}`}
                                        style={labelStyle}
                                        class="facet-checkbox"
                                    >
                                        <span class="visually-hidden">
                                            {value.value}
                                        </span>
                                    </label>
                                </li>
                            );
                        })}

                 </ul>
                )}
            </div>
        </li>
    )
}
